import type { TLAIDefinedRoles, TLAIUserInfo } from '@/types/api';

export function getUserRoles(user: TLAIUserInfo) {
  return Array.isArray(user.realm_access) ? user.realm_access : user.realm_access?.roles;
}

// Checks if the user has any of the given roles
export function userHasRoles(user: TLAIUserInfo, roles: TLAIDefinedRoles[]) {
  return getUserRoles(user)?.some((role) => roles.includes(role)) ?? false;
}

export function userHasRole(user: TLAIUserInfo, role: TLAIDefinedRoles) {
  return getUserRoles(user)?.includes(role) ?? false;
}
